const locale = {
  'Download.unnamedDownloadFile': '未命名下载文件',
  'Download.unNamedDownloadFile': '未命名下载文件',
  'Download.notFoundFile': '未获取到下载的文件信息',
  'Download.downloadSuccess': '下载成功',
  'FileUpload.fileUpload': '上传文件',
  'FileUpload.uploadTips': '支持扩展名{accept}，单个文件大小不超过{fileSize}M，最多上传{maxLength}个附件',
  'FileUpload.maxLengthError': '上传文件不能超过最大允许数量{maxLength}',
  'FileUpload.fileSizeError': '文件{filename}不能超过{fileSize}MB!',
  'FileUpload.acceptError': '文件{filename}格式不符合要求，仅支持{accept}',
  'FileUpload.uploadError': '文件{filename}上传错误{error}',
  'FileUpload.uploadAnomaly': '文件{filename}上传异常{error}',
  'FileUpload.separator': '、',
  'FilePreview.fileLoadedError': '文件加载失败',
  'FilePreview.fileNotFoundError': '未指定文件',
  'FilePreview.pageNotFoundError': '未指定页面',
  'FilePreview.unSupportFileType': '不支持的文件类型',
  'FilePreview.unSupportFileTypeDescription': '系统不支持该文件类型预览，请下载到本地后进行预览',
  'FilePreview.filePreview': '文件预览',
  'FilePreview.zipArchive': '压缩包',
  'FilePreview.fileName': '文件名',
  'FilePreview.fileSize': '文件大小',
  'FilePreview.compressedSize': '压缩后大小',
  'FilePreview.remotePreview': '原生预览',
  'FilePreview.localPreview': '本地预览',
  'FileList.uploading': '正在上传',
  'FileButton.pleaseSetApi': '请在Global组件设置preset.apis.file.getUrl参数',
  'FileSystem.viewGrid': '网格',
  'FileSystem.viewList': '列表',
  'FileSystem.viewColumns': '分栏',
  'FileSystem.viewGallery': '画廊',
  'FileSystem.columnName': '名称',
  'FileSystem.columnSize': '大小',
  'FileSystem.folder': '文件夹',
  'FileSystem.emptyFolder': '此文件夹为空',
  'FileSystem.currentFolder': '当前文件夹',
  'FileSystem.notFound': '未找到"{keyword}"',
  'FileSystem.search': '搜索',
  'FileSystem.resultCount': '个结果',
  'FileSystem.itemCount': '个项目',
  'FileSystem.selected': '已选择 "{name}"'
};

export default locale;
